import { memo } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useCampaignName } from "./hooks";

export const QuestionCampaignName = memo(() => {
	const { name, onSetName } = useCampaignName();

	return (
		<QuestionForMain
			required={true}
			title="キャンペーン名"
			guide="キャンペーンの内容が伝わるシンプルな名前にしましょう。"
			inputChildren={<InputTextField errorMessage={name.error} value={name.value} handleChange={onSetName} />}
		/>
	);
});

QuestionCampaignName.displayName = "QuestionCampaignName";
